import { render } from "./Footer.vue?vue&type=template&id=94b1b2e2"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
script.render = render

export default script